import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ClienteCaso } from '../../../interfaces/cliente.types';
import styles from './CasoTable.module.css';
import { Edit, Trash2, Eye, Loader, Send } from 'lucide-react';

interface CasoTableProps {
    casos: ClienteCaso[];
    onEdit: (caso: ClienteCaso) => void;
    onDelete: (caso: ClienteCaso) => void;
    onViewDetails: (id: number) => void;
        onSendEmail: (id: number) => void;
    sendingEmailId: number | null;
     onStatusClick: (caso: ClienteCaso) => void;
}

export const CasoTable: React.FC<CasoTableProps> = ({ casos, onEdit, onDelete, onViewDetails , onSendEmail,onStatusClick, sendingEmailId}) => {
    
    const rowVariants = {
        hidden: { opacity: 0, y: 15 },
        visible: (i: number) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.05,
                type: 'spring',
                stiffness: 300,
                damping: 24
            }
        })
    };
    
    if (casos.length === 0) {
        return <div className={styles.emptyState}>No se encontraron casos para el filtro seleccionado.</div>
    }

    return (
        <div className={styles.tableContainer}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>N° Expediente</th>
                        <th>Cliente</th>
                        <th>Tipo de Caso</th>
                        <th>Monto Acordado</th>
                        <th>Estado</th>
                        <th className={styles.actionsHeader}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {casos.map((caso, i) => {
                        const isSending = sendingEmailId === caso.id;
                        return (
                            <motion.tr 
                                key={caso.id}
                                custom={i}
                                variants={rowVariants}
                                initial="hidden"
                                animate="visible"
                                exit="hidden"
                                layout
                            >
                                <td data-label="Expediente">{caso.numero_expediente || 'N/A'}</td>
                                <td data-label="Cliente">{caso.nombre_completo}</td>
                                <td data-label="Tipo de Caso">{caso.tipo_caso}</td>
                                <td data-label="Monto">
                                    {`S/.${caso.monto_total_acordado?.toLocaleString('es-PE', { minimumFractionDigits: 2 }) || '0.00'}`}
                                </td>
                                <td data-label="Estado">
                                <button 
                                    className={`${styles.statusBadge} ${styles[`status${caso.estado_caso.replace(' ', '')}`]}`}
                                    onClick={() => onStatusClick(caso)}
                                    title="Cambiar Estado"
                                >
                                    {caso.estado_caso}
                                </button>
                            </td>
                                <td data-label="Acciones">
                                    <div className={styles.actionsCell}>
                                        <button onClick={() => onViewDetails(caso.id)} className={styles.actionButton} title="Ver Detalles">
                                            <Eye size={18} />
                                        </button>
                                        <button onClick={() => onEdit(caso)} className={styles.actionButton} title="Editar Caso">
                                            <Edit size={18} />
                                        </button>
                                        <button 
                                            onClick={() => onSendEmail(caso.id)} 
                                            className={`${styles.actionButton} ${styles.emailButton}`} 
                                            title="Enviar Resumen por Email"
                                            disabled={isSending}
                                        >
                                            {isSending ? <Loader size={18} className={styles.spinner} /> : <Send size={18} />}
                                        </button>
                                        <button onClick={() => onDelete(caso)} className={`${styles.actionButton} ${styles.deleteButton}`} title="Eliminar Caso">
                                            <Trash2 size={18} />
                                        </button>
                                    </div>
                                </td>
                            </motion.tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};